import { useLang } from '@/i18n';
import EcoPicture from 'eco-design/base/eco-picture';
import css from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('aboutus.A');

    return (
        <section id="about-us-A" className={`about-us-A ${css.section} GtmModuleData-section`} data-section-id="About-Us-A">
            <div className="img">
                <EcoPicture
                    className="picture"
                    fetchPriority="high"
                    loading="eager"
                    jpg={[
                        'https://websiteoss.ecoflow.com/figma-uploads/1767774675615-g450ut-compressed-home-carousel-banner.jpg',
                        'https://websiteoss.ecoflow.com/figma-uploads/1767774700508-vdzy8g-compressed-pad.jpg',
                        'https://websiteoss.ecoflow.com/figma-uploads/1767774720171-106yxu-compressed-mob.jpg',
                    ]}
                    alt={t('title')}
                />
            </div>
            <div className="info">
                <div className="title">{t('title')}</div>
                <div className="desc">{t('desc')}</div>
            </div>
        </section>
    );
}
